import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-85ac744a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "workout",
  class: "view"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = {
  key: 0,
  class: "workout-container"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "bottom" }, null, -1))
const _hoisted_6 = { key: 1 }

import {
    ComputedRef,
    Ref,
    computed,
    ref,
    toRefs,
    watch,
    onBeforeMount,
    onUnmounted,
  } from 'vue'
  import { useRoute } from 'vue-router'

  import NotFound from '@/components/Common/NotFound.vue'
  import WorkoutDetail from '@/components/Workout/WorkoutDetail/index.vue'
  import WorkoutChart from '@/components/Workout/WorkoutDetail/WorkoutChart/index.vue'
  import WorkoutNotes from '@/components/Workout/WorkoutDetail/WorkoutNotes.vue'
  import WorkoutSegments from '@/components/Workout/WorkoutDetail/WorkoutSegments.vue'
  import {
    AUTH_USER_STORE,
    SPORTS_STORE,
    WORKOUTS_STORE,
  } from '@/store/constants'
  import { ISport } from '@/types/sports'
  import { IAuthUserProfile } from '@/types/user'
  import { IWorkoutData, IWorkoutPayload, TCoordinates } from '@/types/workouts'
  import { useStore } from '@/use/useStore'

  interface Props {
    displaySegment: boolean
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    displaySegment: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    displaySegment: boolean
  }

  

  const route = useRoute()
  const store = useStore()

  const { displaySegment } = toRefs(props)
  const workoutData: ComputedRef<IWorkoutData> = computed(
    () => store.getters[WORKOUTS_STORE.GETTERS.WORKOUT_DATA]
  )
  const authUser: ComputedRef<IAuthUserProfile> = computed(
    () => store.getters[AUTH_USER_STORE.GETTERS.AUTH_USER_PROFILE]
  )
  const sports: ComputedRef<ISport[]> = computed(
    () => store.getters[SPORTS_STORE.GETTERS.SPORTS]
  )
  let markerCoordinates: Ref<TCoordinates> = ref({
    latitude: null,
    longitude: null,
  })

  onBeforeMount(() => {
    const payload: IWorkoutPayload = { workoutId: route.params.workoutId }
    if (props.displaySegment) {
      payload.segmentId = route.params.segmentId
    }
    store.dispatch(WORKOUTS_STORE.ACTIONS.GET_WORKOUT_DATA, payload)
  })

  onUnmounted(() => {
    store.commit(WORKOUTS_STORE.MUTATIONS.EMPTY_WORKOUT)
  })

  function updateCoordinates(coordinates: TCoordinates) {
    markerCoordinates.value = {
      latitude: coordinates.latitude,
      longitude: coordinates.longitude,
    }
  }

  watch(
    () => route.params.workoutId,
    async (newWorkoutId) => {
      if (newWorkoutId) {
        store.dispatch(WORKOUTS_STORE.ACTIONS.GET_WORKOUT_DATA, {
          workoutId: newWorkoutId,
        })
      }
    }
  )
  watch(
    () => route.params.segmentId,
    async (newSegmentId) => {
      if (route.params.workoutId) {
        const payload: IWorkoutPayload = {
          workoutId: route.params.workoutId,
        }
        if (newSegmentId) {
          payload.segmentId = newSegmentId
        }
        store.dispatch(WORKOUTS_STORE.ACTIONS.GET_WORKOUT_DATA, payload)
      }
    }
  )

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(sports).length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_unref(workoutData).workout.id)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(WorkoutDetail, {
                    workoutData: _unref(workoutData),
                    sports: _unref(sports),
                    authUser: _unref(authUser),
                    markerCoordinates: _unref(markerCoordinates),
                    displaySegment: _unref(displaySegment)
                  }, null, 8, ["workoutData", "sports", "authUser", "markerCoordinates", "displaySegment"]),
                  (
              _unref(workoutData).workout.with_gpx && _unref(workoutData).chartData.length > 0
            )
                    ? (_openBlock(), _createBlock(WorkoutChart, {
                        key: 0,
                        workoutData: _unref(workoutData),
                        authUser: _unref(authUser),
                        displaySegment: _unref(displaySegment),
                        onGetCoordinates: updateCoordinates
                      }, null, 8, ["workoutData", "authUser", "displaySegment"]))
                    : _createCommentVNode("", true),
                  (!_unref(displaySegment) && _unref(workoutData).workout.segments.length > 1)
                    ? (_openBlock(), _createBlock(WorkoutSegments, {
                        key: 1,
                        segments: _unref(workoutData).workout.segments,
                        useImperialUnits: _unref(authUser).imperial_units
                      }, null, 8, ["segments", "useImperialUnits"]))
                    : _createCommentVNode("", true),
                  (!_unref(displaySegment))
                    ? (_openBlock(), _createBlock(WorkoutNotes, {
                        key: 2,
                        notes: _unref(workoutData).workout.notes
                      }, null, 8, ["notes"]))
                    : _createCommentVNode("", true),
                  _hoisted_5
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (!_unref(workoutData).loading)
                    ? (_openBlock(), _createBlock(NotFound, {
                        key: 0,
                        target: "WORKOUT"
                      }))
                    : _createCommentVNode("", true)
                ]))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})